<template>
    <div>
        <modal ref="modal" size="lg"><span slot="title">Edit Group</span>
            <div class="d-flex justify-content-center">
                <ul class="nav nav-navs swell-settings-nav">
                    <li class="nav-item col-6">
                        <a class="nav-link" :class="active ? 'active' : ''" @click="active = true">Group</a>
                    </li>

                    <li class="nav-item col-6">
                        <a class="nav-link" :class="!active ? 'active' : ''" @click="active = false">Contacts</a>
                    </li>
                </ul>
            </div>

            <div class="tab-content">
                <div class="form-group tab-pane fade show active" v-if="active" id="edit-group">
                    <div v-if="form">

                        <input-text label="Name" field="name"
                            v-model="form.name"
                            :form="form"
                            :disabled="form.name === 'All Contacts'">
                        </input-text>

                        <div class="form-group" :class="{'is-invalid': form.errors.has('locations')}" v-if="form.name !== 'All Contacts'">
                            <label>Location(s)</label>

                            <multiselect
                                v-model="form.locations"
                                placeholder="Search or add a location"
                                track-by="id"
                                label="name"
                                :options="locations"
                                :multiple="true">
                            </multiselect>

                            <p class="invalid-feedback" v-if="form && form.errors.has('locations')">
                                {{ form.errors.get('locations') }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="form-group tab-pane fade show active" role="tabcard" id="edit-contact" v-if="!active">
                    <contacts :groupId="groupId"></contacts>
                </div>
            </div>

            <div slot="footer">
                <div class="btn-group">
                    <div class="pb-2 float-right" v-if="!active">
                        <button class="btn btn-info" @click="addAllContactsToGroup"><i class="fa fa-plus"></i> Add All Contacts To Group & Save</button>
                    </div>
                    <div  v-if="form">
                        <button-loading class="btn btn-primary ml-1" type="button" @click="save" :loading="form.submitting">Save changes</button-loading>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            group: {default: () => ({})}
        },

        data() {
            return {
                form: null,
                contacts: [],
                locations: [],
                groupId: null,
                active: null
            }
        },

        watch: {
            group() {
                this.fetchLocations();
                this.form = this.setupForm();
                this.groupId = this.group.id;
                this.active = true;
            }
        },

        methods: {
            open() {
                this.$refs.modal.open();
            },

            close() {
                this.$emit('saved');
                this.$refs.modal.close();
            },

            save() {
                this.form.put('groups/' + this.form.id)
                    .then(() => {
                        this.close();
                        const message = 'Group Updated';
                        this.$alert({message, type: 'success', title: 'Success!'});
                        Bus.$emit('LoadGroupList');
                    })
            },

            setupForm() {
                return new Form({
                    id          : this.group.id,
                    name        : this.group.name || null,
                    locations    : this.group.locations || null,
                });
            },

            fetchLocations() {
                return this.$http.get(this.$laroute.route('api.locations.index'))
                    .then(({data}) => {
                        this.locations = data.data;
                    });
            },

            addAllContactsToGroup(){
                if (this.group.id) {

                    let form = new Form({
                        allContacts: true,
                        groups     : [{
                            id     : this.group.id,
                        }],
                    });

                    let options = {
                        text             : 'This will select and save all contacts to the selected group. (' + this.group.name + ')',
                        confirmButtonText: 'Yes, Assign All Available Contacts to List',
                        type             : 'warning',
                    };

                    this.$confirm(options).then(() => {
                        form.post(this.$laroute.route('contacts-to-group'))
                            .then((response) => {
                                this.close();
                                const message = 'Group Updated';
                                this.$alert({message, type: 'success', title: 'Contacts Added to Group Successfully!'});
                                Bus.$emit('LoadGroupList');
                            });
                    }).catch(err => console.log('err from block', err));
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .is-invalid {
        .invalid-feedback {
            display: block;
        }
    }
</style>
